export default "__VITE_ASSET__BW$4xvq$__"